// Angular imports
import { signal, WritableSignal } from "@angular/core";

//local imports
import { AppAvailability } from "./app-availability.model";


//TODO:DIW:Rename AppManagementModel
export class AppManagementModel {
  public apps: WritableSignal<AppAvailability> = signal<AppAvailability>(undefined);
}


export class NotificationState {
  public notifications: WritableSignal<any[]> = signal<any[]>([]);
}
